var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7666 7.97656L14.8291 13.0391C15.1104 13.3203 15.1104 13.8359 14.8291 14.1172L13.6572 15.2891C13.376 15.5703 12.8604 15.5703 12.5791 15.2891L7.56348 10.2266L2.50098 15.2891C2.21973 15.5703 1.7041 15.5703 1.42285 15.2891L0.250977 14.1172C-0.0302734 13.8359 -0.0302734 13.3203 0.250977 13.0391L5.31348 7.97656L0.250977 2.96094C-0.0302734 2.67969 -0.0302734 2.16406 0.250977 1.88281L1.42285 0.710938C1.7041 0.429688 2.21973 0.429688 2.50098 0.710938L7.56348 5.77344L12.5791 0.710938C12.8604 0.429688 13.376 0.429688 13.6572 0.710938L14.8291 1.88281C15.1104 2.16406 15.1104 2.67969 14.8291 2.96094L9.7666 7.97656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a5d8188112c84d0d9364b98962c03f13.svg";
export { ForwardRef as ReactComponent };